import { IonFooter } from '@ionic/react'
import { trash, checkmarkCircleOutline } from 'ionicons/icons'
import { IconButton } from '~/shared/ui/Buttons'
import { myPalette } from '~/shared/ui/theme'
import { IonToolbar, ToolbarWrapper } from '../styled'
import { Wrapper } from './styled'

type PreviewPhotoProps = {
  photo: Blob
  onOk: (blob: Blob) => void
  onDelete: () => void
  loading: boolean
}

export function PreviewPhoto({
  photo,
  onDelete,
  onOk,
  loading,
}: PreviewPhotoProps) {
  const handleOk = async () => {
    onOk(photo)
  }

  return (
    <>
      <Wrapper>
        <img
          src={URL.createObjectURL(photo)}
          alt='фото'
          width='100%'
          height='auto'
        />
      </Wrapper>
      <IonFooter>
        <IonToolbar>
          <ToolbarWrapper>
            <IconButton
              onClick={onDelete}
              icon={trash}
              style={{ fontSize: '16px', padding: '6px' }}
              iconProps={{ style: { color: myPalette.red.main } }}
              size='large'
              variant='fillWhite'
              data-testid='delete-painter'
            />

            <IconButton
              onClick={handleOk}
              icon={checkmarkCircleOutline}
              style={{ fontSize: '16px', padding: '6px' }}
              iconProps={{
                style: { color: myPalette.green['600'] },
              }}
              size='large'
              data-testid='save-photo'
              variant='fillWhite'
              loading={loading}
            />
          </ToolbarWrapper>
        </IonToolbar>
      </IonFooter>
    </>
  )
}
